import { useTheme, type SxProps } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

import Box, { type BoxProps } from "ui/atom/Box";
import Button, { type ButtonProps } from "ui/base/Button";

type Props = {
	image?: string;
} & ButtonProps;

type FullProps = {
	name?: string;
	size: number;
	sx: SxProps
	image?: string;
} & BoxProps;

Profile.Full = ({ name, size, sx, image, ...props }: FullProps) => {
	const style = {
		root: { alignItems: "center" },
		avatar: { width: size, height: size }
	};

	return (
		<Box gap={2} sx={{ ...style.root, ...sx }} {...props}>
			<Avatar src={image} sx={style.avatar} />
			<Typography variant="caption" color="text.primary">{name}</Typography>
		</Box>
	);
};

export default function Profile({ image, children, ...props }: Props) {
	const theme = useTheme();
	const style = {
		root: {
			p: 0,
			gap: 0.5,
			"&.Mui-disabled": {
				color: "white"
			}
		},
		avatar: {
			m: theme.spacing(1)
		}
	};
	return (
		<Button {...props} sx={{ ...style.root, ...props.sx }} disabled={!props.onClick}>
			{children}
			<Avatar src={image} sx={style.avatar} />
		</Button>
	);
}